import React from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { formatDateBR, formatValor } from "../../helpers/formaters";

export const parseBRLToNumber = (value) => {
  if (value === null || value === undefined || value === "") return 0;
  if (typeof value === "number") return value;
  const cleanValue = String(value)
    .replace("R$", "")
    .replace(/\s/g, "")
    .replace(/\./g, "")
    .replace(",", ".");
  return parseFloat(cleanValue) || 0;
};

export default function ParcelasTable({
  rows = [],
  height = 220,
  primaryColor = "#669966",
  // 1. Novas colunas padrão (caso não passe nada)
  columns = [
    { label: "Emissão", key: "emissao", width: 140, type: "date" },
    { label: "Vencimento", key: "vencimento", width: 160, type: "date" },
    { label: "Parc.", key: "parcela", width: 80, align: "right" },
    {
      label: "Valor",
      key: "valor",
      width: 120,
      align: "right",
      type: "currency",
    },
  ],
}) {
  const total = rows.reduce((acc, r) => acc + parseBRLToNumber(r.valor), 0);

  // Função auxiliar para renderizar o dado conforme o tipo
  const renderCellContent = (row, col) => {
    const value = row[col.key];
    if (col.type === "date") return formatDateBR(value) || "";
    if (col.type === "currency") return value ? formatValor(value, true) : "";
    return value || "";
  };

  return (
    <Paper
      variant="outlined"
      sx={{ borderRadius: 1, overflow: "hidden", borderColor: "divider" }}
    >
      <Box
        sx={{
          px: 2,
          py: 0.5,
          bgcolor: primaryColor,
          color: "white",
          fontWeight: 700,
          fontSize: 13,
        }}
      >
        Parcelas
      </Box>

      <Box
        sx={{
          maxHeight: height,
          overflowY: "auto",
          borderBottom: "1px solid",
          borderColor: "divider",
        }}
      >
        <Table
          size="small"
          sx={{
            tableLayout: "fixed",
            "& th, & td": { fontSize: 12, py: 0.35 },
          }}
        >
          <TableHead>
            <TableRow
              sx={{
                "& th": {
                  bgcolor: `${primaryColor}1F`,
                  fontWeight: 800,
                  color: "rgba(0,0,0,0.78)",
                },
              }}
            >
              {/* 2. Mapeamento das colunas dinâmicas no Header */}
              {columns.map((col, i) => (
                <TableCell
                  key={i}
                  align={col.align || "left"}
                  sx={{ width: col.width }}
                >
                  {col.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.length === 0 ? (
              <TableRow>
                {/* O colSpan agora é dinâmico baseado no número de colunas */}
                <TableCell
                  colSpan={columns.length}
                  sx={{ py: 1.2, color: "text.secondary" }}
                >
                  Nenhuma parcela gerada.
                </TableCell>
              </TableRow>
            ) : (
              rows.map((r, idx) => (
                <TableRow key={r.id ?? idx} hover>
                  {/* 3. Mapeamento dos dados dinâmicos nas células */}
                  {columns.map((col, i) => (
                    <TableCell
                      key={i}
                      align={col.align || "left"}
                      sx={{
                        whiteSpace: "nowrap",
                        fontWeight: col.type === "currency" ? 700 : 400,
                      }}
                    >
                      {renderCellContent(r, col)}
                    </TableCell>
                  ))}
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </Box>

      <Box
        sx={{
          px: 1,
          py: 0.75,
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          gap: 1,
          bgcolor: `${primaryColor}0F`,
        }}
      >
        <Typography sx={{ fontSize: 12, fontWeight: 800 }}>Total:</Typography>
        <Box
          sx={{
            minWidth: 120,
            textAlign: "right",
            px: 1,
            py: 0.35,
            border: `1px solid black`,
            borderRadius: 0.75,
            bgcolor: "white",
            fontSize: 12,
            fontWeight: 800,
          }}
        >
          {formatValor(total.toFixed(2).replace(".", ","), true)}
        </Box>
      </Box>
    </Paper>
  );
}
